// removed by extract-text-webpack-plugin
module.exports = {"CountersigningPanel":"CountersigningPanel__CountersigningPanel___18HFG","csActionsItem":"CountersigningPanel__csActionsItem___1Rfzt","row":"CountersigningPanel__row___2k_4_"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/VPRekla/EditComplaint/CountersigningPanel/CountersigningPanel.scss
// module id = 738
// module chunks = 0